'use client'

import Link from 'next/link'

import { Navbar, NavbarLink } from '@portal/taonga-ui'

import { css } from '@news/styled-system/css'
import { useI18n } from '@/shared/providers'

export function NavbarError() {
    const { i18n } = useI18n()

    return (
        <Navbar className={css({ width: 'full!', justifyContent: 'center!' })}>
            <Navbar.LinkList className={css({ width: { base: 'full', xl: '[1048px]' }, height: 'full' })}>
                <Link href="/">
                    <NavbarLink>{i18n.BUTTON_NEWS}</NavbarLink>
                </Link>
            </Navbar.LinkList>
        </Navbar>
    )
}
